import { isBrowser } from './env';

const isTest = () => {
  if (!isBrowser) return false;
  return window.top?.location.host.includes('-test-');
};
/**
 * 转换为相对路径
 * https://fh-static.bycsi.com/abc.svg
 * =>
 * /common-static/fhs/abc.svg
 */
export function absoluteToRelative(src: string) {
  if (!isTest() && src.match(/^https:\/\/fh-static.bycsi.com/)) {
    return `/common-static/fhs/${src.replace(
      /^https:\/\/fh-static.bycsi.com\//,
      ''
    )}`;
  }
  return src;
}

/**
 * 转换为绝对路径
 * /common-static/fhs/abc.svg
 * =>
 * https://fh-static.bycsi.com/abc.svg
 */
export function relativeToAbsolute(src: string) {
  if (!isTest() && src.match(/^\/common-static\/fhs/)) {
    return `https://fh-static.bycsi.com/${src.replace(
      /^\/common-static\/fhs\//,
      ''
    )}`;
  }
  return src;
}
